<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch6">
<div class="chapterHead">
<p class="centerImage3"><img alt="image" src="images/ch6.jpg" width="5%"/></p>
</div>
<p class="para" style="text-indent: 5%;"><a id="pg-6">“Use the key and open the lock!” the woman begs.</a></p><a id="pg-6">
<p class="para" style="text-indent: 5%;">You hear the dragon’s heavy footsteps approaching. “What key?” you ask.</p>
<p class="para" style="text-indent: 5%;">“The key around your neck!”</p>
<p class="para" style="text-indent: 5%;">You glance down at the chronometer. It seems to be the same shape as the keyhole. “But this isn’t a key,” you protest. “It’s a chronometer!”</p>
<p class="para" style="text-indent: 5%;">“I don’t care what it is!” the woman cries. “Use it!”</p>
<p class="para" style="text-indent: 5%;">At that moment flames shoot out of the opening in the wall. The dragon’s huge, scaly face appears. Its evil yellow eyes narrow when it sees you.</p>
<p class="para" style="text-indent: 5%;">Quick! Make a decision! Should you try to use the chronometer as a key to rescue the woman? Or should you just get out of there as fast as you can?</p>
<p class="para" style="text-indent: 5%;">Hurry! The dragon’s about to breathe fire again!</p>
</a><p class="extractLetterText" style="text-indent: 5%;"><a id="pg-6"><em class="italic">Use the chronometer on </em></a><span href="#/e9780545841016_ch094" title="Link target outside of Sample"><em class="italic">PAGE 94</em></span>.</p>
<p class="para" style="text-indent: 5%;"><em class="italic">Run out of the room on <span href="#/e9780545841016_ch117" title="Link target outside of Sample"><em class="italic">PAGE 117</em></span>.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780545841016_ch006.vue?469abb19